import React from "react";
import "./index.css";
import "../DotNetSplash/layout-1.css";
import cn from "classnames";
import BgTransformer from "layout/BgTransformer";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import ImageUpload from "layout/ImageUpload";
import PixelationLayer from "layout/PixelationLayer";
import {useSetting} from "contexts/setting";
import {useEdits} from "contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {checkIfIDE} from "data/products/index";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {PLACEHOLDERS} from "../../../data/constants";

const DotNetSplash2x = ({id, zoom}) => {
  const {product, type, channel, layoutOption} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {versions, productNames} = useEdits();

  const defaultProductName = product.altLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const logoSrc = useLogoUrl(id);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});
  const version = versions[id] ?? versions.main ?? PLACEHOLDERS.en.version;

  return (
    <div
      id={id}
      className={cn("template", product.value, "dotnet-splash-2x", `layout-${layoutOption}`)}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        {/* 2× tiles: this is the @2x variant on a doubled canvas, so match the
            base DotNetSplash mosaic's visual square size instead of half-size. */}
        <PixelationLayer scale={2} />
        <div className="content">
          <div className="product-name">
            <ContentEditable id={id} text={productName} />
          </div>
          <div className="version">
            <div className="textarea">
              <ContentEditable id={id} text={version} />
            </div>
          </div>
          <header className="template-header">
            <div className={logoClass}>
              <img src={logoSrc} alt="logo" />
            </div>
          </header>
        </div>
        {[5, 6].includes(+layoutOption) && (
          <div className="upload-wrap">
            <ImageUpload id={id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default DotNetSplash2x;
